import axios from 'axios'
const url = '/proveedores'
export default {
    index() {
        return axios.get(`${url}`)
    },

    show(id) {
        return axios.get(`${url}/${id}`)
    },
    create(data) {

        return axios.post(`${url}`, data)
    },

    update(data) {
        return axios.put(`${url}/${data.id}`, data)
    },


    delete(id, data) {
        return axios.delete(`${url}/${id}`, data)


    },
    conListaDePrecios() {
        let url = "/proveedores/proveedorconlista";
        return axios.get(url);
      },

    // Estado de cuenta: facturas con saldo, pagos a cuenta y últimos pagos
    pagos(id) {
        return axios.get(`/comprobantes/compra/proveedor/${id}/pagos`)
    },
    // Pago al proveedor: se imputa de la factura más vieja a la más nueva,
    // lo que sobra queda a cuenta. Mismo endpoint que el pago por factura.
    pagar(data) {
        return axios.post('/comprobantes/compra/pagar', data)
    },
    // Formas de pago habilitadas para pagar desde una sucursal concreta
    formasDePago(sucursalUuid) {
        return axios.get('/comprobantes/formasdepago/cobro', { params: { sucursal: sucursalUuid, para: 'pago' } })
    },

}